const Escape = {
    key: 'Escape',
    code: 'Esc',
};
const PageUp = {
    key: 'PageUp',
    code: 'Numpad9',
};
const PageDown = {
    key: 'PageDown',
    code: 'Numpad3',
};
const Enter = {
    key: 'Enter',
    code: 'Enter',
};
const Space = {
    key: ' ',
    code: 'Space',
};
const Backspace = {
    key: 'Backspace',
    code: 'Backspace',
};
const Delete = {
    key: 'Delete',
    code: 'Delete',
};
const Home = {
    key: 'Home',
    code: 'Home',
};
const End = {
    key: 'End',
    code: 'End',
};
const ArrowRight = {
    key: 'ArrowRight',
    code: 'ArrowRight',
};
const ArrowLeft = {
    key: 'ArrowLeft',
    code: 'ArrowLeft',
};
const ArrowUp = {
    key: 'ArrowUp',
    code: 'ArrowUp',
};
const ArrowDown = {
    key: 'ArrowDown',
    code: 'ArrowDown',
};
const Tab = {
    key: 'Tab',
    code: 'Tab',
};
const DigitKeys = [
    {
        key: '0',
        code: 'Digit0',
    },
    {
        key: '1',
        code: 'Digit1',
    },
    {
        key: '2',
        code: 'Digit2',
    },
    {
        key: '3',
        code: 'Digit3',
    },
    {
        key: '4',
        code: 'Digit4',
    },
    {
        key: '5',
        code: 'Digit5',
    },
    {
        key: '6',
        code: 'Digit6',
    },
    {
        key: '7',
        code: 'Digit7',
    },
    {
        key: '8',
        code: 'Digit8',
    },
    {
        key: '9',
        code: 'Digit9',
    },
];

var keys = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ArrowDown: ArrowDown,
    ArrowLeft: ArrowLeft,
    ArrowRight: ArrowRight,
    ArrowUp: ArrowUp,
    Backspace: Backspace,
    Delete: Delete,
    DigitKeys: DigitKeys,
    End: End,
    Enter: Enter,
    Escape: Escape,
    Home: Home,
    PageDown: PageDown,
    PageUp: PageUp,
    Space: Space,
    Tab: Tab
});

export { ArrowUp as A, Backspace as B, Delete as D, Escape as E, Home as H, PageUp as P, Space as S, Tab as T, ArrowRight as a, ArrowDown as b, ArrowLeft as c, PageDown as d, Enter as e, End as f, DigitKeys as g, keys as k };
//# sourceMappingURL=keys-BQYfE7yD.js.map
